(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ev-home-redesign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ev-parts-finder')) {
 customElements.define('ev-parts-finder', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   const tabs = [...this.querySelectorAll('[data-search-tab]')];
   const panels = [...this.querySelectorAll('[data-search-panel]')];
   const activate = tab => {
    tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = panel.dataset.searchPanel !== tab.dataset.searchTab; });
   };
   tabs.forEach((tab,index) => {
    tab.addEventListener('click', () => activate(tab), options);
    tab.addEventListener('keydown', event => {
     let next = index;
     if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
     else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
     else if (event.key === 'Home') next = 0;
     else if (event.key === 'End') next = tabs.length - 1;
     else return;
     event.preventDefault(); activate(tabs[next]); tabs[next].focus();
    }, options);
   });
   activate(tabs[0]);
   this.querySelectorAll('button[disabled]').forEach(button => { button.disabled = false; });
   const vinInput = this.querySelector('[data-vin-form] input');
   const status = this.querySelector('[data-vin-status]');
   const model = this.querySelector('[data-model-form] select');
   const navigate = value => { const target = new URL(value, location.origin); if (target.origin === location.origin) location.assign(target.href); };
   this.querySelector('[data-model-form]').addEventListener('submit', event => { event.preventDefault(); if (model.value) navigate(model.value); }, options);
   vinInput.addEventListener('input', () => { vinInput.setCustomValidity(''); vinInput.removeAttribute('aria-invalid'); status.textContent = ''; }, options);
   this.querySelector('[data-vin-form]').addEventListener('submit', event => {
    event.preventDefault();
    const vin = vinInput.value.toUpperCase().replace(/[\s-]/g, '');
    vinInput.value = vin;
    let error = '';
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) error = this.dataset.vinError;
    const years = { H:2017,J:2018,K:2019,L:2020,M:2021,N:2022,P:2023,R:2024,S:2025,T:2026,V:2027 };
    const year = years[vin[9]];
    const base = vin[3] === '3' ? 'Model 3' : vin[3] === 'Y' ? 'Model Y' : '';
    if (!error && (!/^(5YJ|7SA|LRW|XP7)/.test(vin) || !year || !base || (base === 'Model Y' && year < 2020))) error = this.dataset.unsupported;
    const name = base === 'Model 3' && year >= 2024 ? 'Model 3 Highland' : base === 'Model Y' && year >= 2025 ? 'Model Y Juniper' : base;
    const match = [...model.options].find(option => option.dataset.model?.trim().toLowerCase() === name.toLowerCase());
    if (!error && !match?.value) error = this.dataset.unsupported;
    if (error) { status.textContent = error; vinInput.setAttribute('aria-invalid','true'); vinInput.focus(); return; }
    navigate(match.value);
   }, options);
   this.querySelector('[data-part-form]').addEventListener('submit', event => { const input = event.currentTarget.querySelector('[name=q]'); input.value = input.value.trim(); if (!input.value) { event.preventDefault(); input.reportValidity(); } }, options);
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}

if (!customElements.get('ev-hero-slider')) {
  customElements.define('ev-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('.ev-hero-image')];
      this.controls = this.querySelector('.ev-hero-controls');
      if (this.slides.length < 2 || !this.controls) return;
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      this.delay = Math.max(4000, Number(this.dataset.delay) || 6000);
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.controls.hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.controls.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('pointerdown', event => {
        this.touchStart = event.pointerType === 'touch' && !event.target.closest('a,button,input,form') ? { x: event.clientX, y: event.clientY } : null;
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
      }, options);
      this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.paused = true;
        this.updatePause();
        this.schedule();
      }, options);
      this.updatePause();
      this.schedule();
    }
    show(index) {
      if (this.animating) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (nextIndex === this.index) { this.schedule(); return; }
      clearTimeout(this.timer);
      const old = this.slides[this.index];
      const next = this.slides[nextIndex];
      this.index = nextIndex;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      next.classList.add('is-active');
      if (this.reduced.matches) {
        old.classList.remove('is-active');
        this.schedule();
        return;
      }
      this.animating = true;
      const options = { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)' };
      this.animations = [
        old.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}], options),
        next.animate([{transform:'translateX(-100%)'},{transform:'translateX(0)'}], options)
      ];
      Promise.all(this.animations.map(animation => animation.finished)).catch(() => {}).finally(() => {
        old.classList.remove('is-active');
        this.animating = false;
        if (this.isConnected) this.schedule();
      });
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ev-modern-recommendations')) {
  class EvModernRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.performed === 'true' || this.dataset.loading === 'true') return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadCards();
      }, {rootMargin:'400px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async loadCards() {
      this.dataset.loading = 'true';
      this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('.ev-rec-content');
        if (!content?.querySelector('.ev-product')) {this.hidden = true;return;}
        this.querySelector('.ev-rec-content').replaceChildren(...content.childNodes);
        this.dataset.performed = 'true';
        this.dispatchEvent(new CustomEvent('ev:cards:loaded', {bubbles:true}));
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      } finally {
        delete this.dataset.loading;
      }
    }
  }
  customElements.define('ev-modern-recommendations', EvModernRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-vehicle-collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.ev-vc-shell .tpc__side-toggle');
    if (!toggle) return;
    const side = toggle.closest('.tpc__side');
    if (!side) return;
    const open = side.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.ev-vc-shell .ev-vc-search');
    if (!input) return;
    const shell = input.closest('.ev-vc-shell');
    if (!shell) return;
    const query = input.value.trim().toLowerCase();
    const products = Array.from(shell.querySelectorAll('.ev-vc-product'));
    let visible = 0;
    products.forEach((product) => {
      const match = !query || product.textContent.toLowerCase().includes(query);
      product.hidden = !match;
      if (match) visible += 1;
    });
    const empty = shell.querySelector('.ev-vc-empty');
    if (empty) empty.hidden = visible !== 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
